<div class="page-container nofondPage">
  <div class="main-container">
    <div class="container nofondPage-content">
      <img class="nofondPage-content-top" src="assets/images/nofondpage.png" alt="" />
      <div class="nofondPage-content-bottom">
        <div class="tips">{{ 'notfound_tip_1' | translate }}</div>
        <div class="tips">{{ 'notfound_tip_2' | translate }}</div>
        <customize-button class="back" size="large-medium" width="34rem" type="primary-linear" (onClick)="goHome()">
          {{ 'go_home' | translate }}
        </customize-button>
      </div>
    </div>
  </div>
</div>
